import config from '../config';

// ✅ Create a new setting profile
export const createSettingProfile = async (profileInfo) => {
  const resp = await fetch(`${config.apiUrl}/api/setting-profiles`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(profileInfo),
  });
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.message || 'Failed to create profile');
  return data;
};

// ✅ Get all setting profiles for a specific client
export const getSettingProfilesByClient = async (clientId) => {
  const resp = await fetch(`${config.apiUrl}/api/setting-profiles/${clientId}`);
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.message || 'Failed to fetch profiles');
  return data;
};

// ✅ Update an existing setting profile
export const updateSettingProfile = async (profileId, profileInfo) => {
  const resp = await fetch(`${config.apiUrl}/api/setting-profiles/${profileId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(profileInfo),
  });
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.message || 'Failed to update profile');
  return data;
};

// ✅ Delete a setting profile
export const deleteSettingProfile = async (profileId) => {
  const resp = await fetch(`${config.apiUrl}/api/setting-profiles/${profileId}`, {
    method: 'DELETE',
  });
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.message || 'Failed to delete profile');
  return data;
};

// ✅ Link setting profile to an MCU
export const linkProfileToMCU = async ({ mcu_id, profile_id }) => {
  const resp = await fetch(`${config.apiUrl}/api/setting-profiles/link`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ mcu_id, profile_id }),
  });
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.message || 'Failed to link profile to MCU');
  return data;
};

// ✅ Unlink profile from MCU
export const unlinkProfileFromMCU = async (linkId) => {
  const resp = await fetch(`${config.apiUrl}/api/setting-profiles/link/${linkId}`, {
    method: 'DELETE',
  });
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.message || 'Failed to unlink profile');
  return data;
};

// ✅ Get a single setting profile by ID
export const getSettingProfileById = async (profileId) => {
  const resp = await fetch(`${config.apiUrl}/api/setting-profiles/profile/${profileId}`);
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.message || 'Failed to fetch setting profile');
  return data;
};